import fitText from 'javascripts/utils/fit-text';

function textBoxFontSizeCalc($parent, modulNumber) {
  $parent.forEach(($boxWrapper) => {
    let fontSize = 13;
    let gotFitted = false;
    const $items = $boxWrapper.querySelectorAll(`.rsmstorytelling-pi2__${modulNumber}__item`);

    $items.forEach(($item) => {
      const $text = $item.querySelector(`.rsmstorytelling-pi2__${modulNumber}__item-text`);
      const $parentHeight = $text.parentNode.offsetHeight - 20;
      let $textHeight = 0;

      [...$text.children].forEach(($child) => {
        $textHeight += $child.clientHeight;
      });

      if ($parentHeight < $textHeight) {
        const factor = (($text.children[1].innerText.length - 1) / 10);
        const minFontSize = 9;
        const $fittedItem = fitText($text.children[1], factor, { minFontSize, maxFontSize: 13 });
        const fittedSize = parseInt($fittedItem.style.fontSize, 10);
        if (fontSize > fittedSize) {
          fontSize = fittedSize;
        }
        gotFitted = true;
      }
    });
    if (gotFitted) {
      $items.forEach($el => $el.querySelector(`.rsmstorytelling-pi2__${modulNumber}__item-text`).setAttribute('style', `font-size:${fontSize}px;`));
    }
  });
}

function detectSpecialTeasers($slides) {
  $slides.forEach(($slide) => {
    $slide.querySelectorAll('.rsmstorytelling-pi2__3__item').forEach(($item) => {
      const $specialTextNode = $slide.querySelector('.text-center');

      if ($specialTextNode) {
        $item.parentNode.classList.add('rsmstorytelling-pi2__3__zoom--special');
      }
    });
  });
}

function handleTooltipOverflow($parent) {
  const $markers = $parent.querySelectorAll('.rsmstorytelling-pi2__8__marker-bubble');
  const {
    right: parentRight, bottom: parentBottom,
  } = $parent.getBoundingClientRect();

  $markers.forEach(($marker) => {
    const $markerEdited = $marker;

    // Get marker dimensions
    $markerEdited.style.display = 'block';
    const {
      left, right, bottom,
    } = $marker.getBoundingClientRect();
    $markerEdited.style.display = 'none';

    if (bottom > parentBottom) {
      $markerEdited.classList.add('marker-bubble--top');
      $markerEdited.classList.remove('marker-bubble--bottom');
    }

    if (left < 6) {
      $markerEdited.classList.add('marker-bubble--right');
      $markerEdited.classList.remove('marker-bubble--left');
    } else if (right > parentRight) {
      $markerEdited.classList.add('marker-bubble--left');
      $markerEdited.classList.remove('marker-bubble--right');
    }
  });
}

document.querySelectorAll('.rsmstorytelling__slider--holder').forEach(($storytelling) => {
  const textResizeList = [
    [$storytelling.querySelectorAll('.rsmstorytelling-pi2__17__holder'), 17],
    [$storytelling.querySelectorAll('.rsmstorytelling-pi2__4'), 4],
  ];

  textResizeList.forEach(($el) => {
    if ($el[0]) {
      textBoxFontSizeCalc($el[0], $el[1]);
      window.addEventListener('resize', () => textBoxFontSizeCalc($el[0], $el[1]));
    }
  });

  const $3TeaserSlides = $storytelling.querySelectorAll('.rsmstorytelling-pi2__3');
  if ($3TeaserSlides) {
    detectSpecialTeasers($3TeaserSlides);
  }

  const $8Markers = $storytelling.querySelectorAll('.rsmstorytelling-pi2__8');
  $8Markers.forEach($markerSlide => handleTooltipOverflow($markerSlide));
  window.addEventListener('resize', () => $8Markers.forEach($markerSlide => handleTooltipOverflow($markerSlide)));
});
